(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rivo-potential-points"] && !Shopify.designMode) return;
  try {
    var noPointsText = document.querySelector('.rivo-container-points').getAttribute('data-no-points-text');

function getUSDValue(localValue) {
  if (window.Shopify && window.Shopify.currency) {
    var rate = window.Shopify.currency.rate;
    // Replace comma with dot for decimal, remove all but digits and dot
    var normalized = localValue.replace(',', '.').replace(/[^0-9.]/g, '');
    var numericValue = Number(normalized);
    return numericValue / rate;
  }
  return Number(localValue.replace(',', '.').replace(/[^0-9.]/g, ''));
}

function updatePotentialPoints(dataValue) {
  let balanceAmount = Number(document.querySelector('.rivo-container-points').getAttribute('data-balance-amount')) || 1;
  let usdValue = getUSDValue(dataValue);
  let roundedValue = Math.ceil(usdValue);
  let points = roundedValue * balanceAmount;
  let pointsSpan = document.getElementById('rivo-points-value');

  if (isNaN(points) || !isFinite(points) || points === 0) {
    // Hide the points text
    let pointsText = document.querySelector('.rivo-points-text');
    if (pointsText) pointsText.style.display = 'none';
  } else {
    // Show the points text
    let pointsText = document.querySelector('.rivo-points-text');
    if (pointsText) pointsText.style.display = '';
    if (pointsSpan) pointsSpan.textContent = points;
  }
  let potentialText = document.querySelector('.rivo-container-points');
  if (potentialText) potentialText.style.display = '';
}

document.addEventListener('DOMContentLoaded', function() {
  let deliveryInputs = document.querySelectorAll('[name="selling_plan"]');
  // Get the default checked input on load
  let checkedInput = document.querySelector('[name="selling_plan"]:checked');
  if (checkedInput) {
    let defaultValue = checkedInput.getAttribute('data-value-points');
    updatePotentialPoints(defaultValue);
  }
  deliveryInputs.forEach(function(input) {
    input.addEventListener('click', function() {
      let dataValue = input.getAttribute('data-value-points');
      updatePotentialPoints(dataValue);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
